var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 -0.25V0.75H10.25V-0.25H11.75V0.75H13.9091C14.6497 0.75 15.25 1.35034 15.25 2.09091V13.9091C15.25 14.6497 14.6497 15.25 13.9091 15.25H2.09091C1.35034 15.25 0.75 14.6497 0.75 13.9091V2.09091C0.75 1.35035 1.35035 0.75 2.09091 0.75H4.25V-0.25H5.75ZM4.25 2.25H2.25V4.75H13.75V2.25H11.75V3.25H10.25V2.25H5.75V3.25H4.25V2.25ZM13.75 6.25H2.25V13.75H13.75V6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ab7d2e1a368dad49dafb50142a68e834.svg";
export { ForwardRef as ReactComponent };